import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { Modal } from 'containers/misc'
import { AssessorAddMore } from 'containers/forms/assessors'
import { FormData, Module } from 'components/misc'
import { apiAssessors, apiOrganizations } from 'helpers/decorators/api'
import { organizationDropdownSelector } from 'redux/selectors/organizations'

@apiOrganizations({
  filter: 'awardUnits'
})
@apiAssessors()
@connect(state => ({
  awardUnits: organizationDropdownSelector(state)
}))
class AssessorAwardUnits extends Component {
  static propTypes = {
    data: PropTypes.object,
    awardUnits: PropTypes.array,
    getOrganizations: PropTypes.func.isRequired,
    inviteAssessor: PropTypes.func.isRequired,
    modal: PropTypes.func.isRequired
  }

  static defaultProps = {
    awardUnits: []
  }

  handleOpenAddMoreModal = () => {
    this.setState({
      isLoading: true
    })
    this.props
      .getOrganizations()
      .then(() => {
        this.props.modal('add-more-aus')
        this.setState({
          isLoading: false
        })
      })
      .catch(() => {
        console.log('error while fetching organizations')
        this.setState({
          isLoading: false
        })
      })
  }

  // add/change functionality will be added here - containers
  render () {
    const { data, awardUnits } = this.props
    let assessorsAwardUnits = get(data, 'organizationContacts') || []

    assessorsAwardUnits = assessorsAwardUnits.filter(au => au.isAssessor)

    const filterredAwardUnits = awardUnits.filter(
      au =>
        !assessorsAwardUnits.some(
          item => get(item, 'organization.id') === au.value
        )
    )

    const buttonDefinition = [
      {
        'order': 1,
        'secondary': true,
        'onClick': this.handleOpenAddMoreModal,
        'iconAction': null,
        'isActionLoading': false,
        'intlKeyAction': 'button.add_more',
        'action': 'Add more'
      }
    ]

    return (
      <div>
        <Module
          title="Award units"
          intlKey="moduleTitle.award_units"
          buttonDefinition={buttonDefinition}
          primary
          grid
        >
          {assessorsAwardUnits.map(item => (
            <div className="row" key={item.id}>
              <div className="col-xs-6">
                <FormData label="Name" intlKey="label.name">
                  {get(item, 'organization.name') || '---'}
                </FormData>
              </div>
              <div className="col-xs-6">
                <FormData label="Region" intlKey="label.region">
                  {get(item, 'organization.region.name') || '---'}
                </FormData>
              </div>
            </div>
          ))}
        </Module>
        <Modal id="add-more-aus" enableOverflow customActions>
          <AssessorAddMore
            data={data}
            awardUnits={filterredAwardUnits}
            modal={this.props.modal}
            onAddMore={this.props.inviteAssessor}
          />
        </Modal>
      </div>
    )
  }
}

export default AssessorAwardUnits
